// extracted by mini-css-extract-plugin
export default {"label":"+Jk2OLLH0sQxXfAYmsQeWw=="};